<template>
  <div>
    <el-table :data="attachedDocs" style="width: 100%" ref="attachementsTable">
      <el-table-column label="Ημερομηνία"  width="120">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="" width="150">
         <template slot-scope="scope">
            <el-button size="mini" type="primary" round @click="downloadPdf(scope.$index, scope.row)"
            icon="el-icon-download">
          </el-button>
          <el-button size="mini" type="primary" round @click="viewPdf(scope.$index, scope.row)"
            icon="el-icon-view">
          </el-button>
         </template>
      </el-table-column>
      <el-table-column label="Δικαιολογητικό">
        <template slot-scope="scope">
          {{ calcType(scope.row.type, scope.row.name) }}
        </template>
      </el-table-column>
      <el-table-column label="Σχόλιο Χρήστη" class="hidden-sm-and-down">
        <template slot-scope="scope">
          {{scope.row.applicantComment}}
        </template>
      </el-table-column>
      <el-table-column label="Σχόλιο Προελέγχου" class="hidden-sm-and-down" v-if='role === "prechecker"'>
        <template slot-scope="scope">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder=""
            v-model="scope.row.precheckerComment"
            @change='commentChanged(scope.$index, scope.row)'
            @dblclick.native='addTextToDoc(scope.$index, scope.row)'>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="ΟΚ" width="50" v-if='role === "prechecker"'>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.precheckerChecked"
            @change='commentChanged(scope.$index, scope.row)'>
          </el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <el-checkbox
      class="select-all-docs"
      v-model="checkAll"
      @change="handleSelectAllChanged"
      v-if='role === "prechecker"'>Επιλογή όλων
    </el-checkbox>
    <hr>
    <!-- <el-form :inline="true" label-width="180px" v-if='role === "prechecker"'> -->
    <el-form :inline="true" label-width="180px">
      <el-form-item label="Σχόλιο από τον αιτούντα" v-show='userComment != ""'>
        {{userComment}}
      </el-form-item>
      <p></p>
      <el-form-item label="Σχόλιο για τον αιτούντα" v-if="showCommentsToApplicantField">
        <!-- <el-input class="biggest" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"
          placeholder="Συνολικό σχόλιο" v-model="generalCommentWork" @change='generalCommentChanged'
          @dblclick.native='addText'>
        </el-input> -->
        <vue-editor v-model='generalCommentWork' :editor-toolbar="customToolbar" class="propcolor"
          @text-change='generalCommentChanged' @dblclick.native='addText'></vue-editor>
      </el-form-item>
      <el-dialog
        v-if="addTextdialogVisible"
        title="Συνήθεις Προτάσεις"
        :visible.sync="addTextdialogVisible"
        width="90%">
          <div v-for="recom in recommendations" :key="recom.id" :value="{id: recom.id, name: recom.description}" :label="recom.description">
              <!-- <span v-html = 'recom.description.length < 140 ? recom.description : recom.description.substring(0, 140) + "<br />" + recom.description.substring(140)'></span> -->
              <div><label><input type="checkbox" @change='toggleText(recom.id, recom.description, $event.target.checked)'
              :value="recom.description" :checked="false"/> {{recom.description}}</label></div>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelTextToComment">Άκυρο</el-button>
          <el-button type="primary" @click="addTextToComment">Επιβεβαίωση</el-button>
        </span>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
import * as axios from 'axios'
import { mapState } from 'vuex'
import { VueEditor } from 'vue2-editor'
import sharedMethods from './sharedMethods.js'

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  components: {
    VueEditor
  },
  mixins: [sharedMethods],
  props: ['userComment', 'generalCommentProp', 'generalCommentWorking',
    'attachedDocumentsTable', 'neededDocuments', 'appId', 'role', 'recommendations', 'isPostExam'],
  data () {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        // ['blockquote', 'code-block'],
        // [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }]
        // ['clean']
      ],
      checkAll: false,
      fromInput: 'generalComment', // doc.index
      checkedTexts: [],
      addTextdialogVisible: false,
      generalCommentWork: this.generalCommentWorking,
      documentComment: '',
      documentType: '',
      attachments: [],
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'pdfs',
      fileCount: 1
    }
  },
  mounted () {
    this.reset()
  },
  computed: {
    showCommentsToApplicantField () {
      return this.role === 'prechecker' && !this.isPostExam
    },
    generalComment () {
      return this.generalCommentProp
        .map(st => (`<p>${st.date}: ${st.judgment.pendingReason}</p>`)).join('')
    },
    // generalCommentWork () {
    //   this.$emit('changedGeneralComment', this.generalCommentWorking)
    //   return this.generalCommentWorking
    // },
    attachedDocs () {
      this.$emit('changedAttachedDocs', this.attachedDocumentsTable)
      return this.attachedDocumentsTable
    },
    attachedDocsTable () {
      return this.attachedDocumentsTable.map(doc => doc.type)
    },
    neededDocumentsLeft () {
      // create 2 arrays of strings and compare them, use only type and not name for neededDocuments
      // let neededDocs = this.neededDocuments.map(doc => doc.type)
      // let attachedDocsTable = this.attachedDocumentsTable.map(doc => doc.type)
      return this.neededDocs.filter(item => !this.attachedDocsTable.includes(item))
    },
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    ...mapState([
      'BASE_URL'
    ])
  },
  methods: {
    handleSelectAllChanged (val) {
      let docs = this.attachedDocs.map(doc => {
        let docum = doc
        docum.precheckerChecked = this.checkAll
        return docum
      })
      this.$emit('changedAttachedDocs', docs)
      this.$store.dispatch('SET_WORKING_APPLICATION_ATTACHMENTS', docs)
    },
    cancelTextToComment () {
      this.addTextdialogVisible = false
      this.checkedTexts = []
    },
    toggleText (id, text, state) {
      state ? this.checkedTexts.push(text) : this.checkedTexts = this.checkedTexts.filter(delText => delText !== text)
    },
    addTextToComment () {
      this.addTextdialogVisible = false
      if (this.checkedTexts.length > 0) {
        if (this.fromInput === 'generalComment') {
          this.generalCommentWork = this.generalCommentWork
            ? this.generalCommentWork + '\n' + this.checkedTexts.reduce((acc, cur) => acc + '\n' + cur)
            : this.checkedTexts.reduce((acc, cur) => acc + '\n' + cur)
          this.generalCommentChanged()
        } else {
          this.attachedDocs[this.fromInput].precheckerComment =
            this.attachedDocs[this.fromInput].precheckerComment
              ? this.attachedDocs[this.fromInput].precheckerComment + '\n' + this.checkedTexts.reduce((acc, cur) => acc + '\n' + cur)
              : this.checkedTexts.reduce((acc, cur) => acc + '\n' + cur)
          this.commentChanged(this.fromInput, '')
        }
      }
      this.checkedTexts = []
    },
    addTextToDoc (index, row) {
      this.fromInput = index
      this.addTextdialogVisible = true
    },
    addText () {
      this.fromInput = 'generalComment'
      this.addTextdialogVisible = true
    },
    b64toBinary (b64Data) {
      let sliceSize = 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return byteArrays
    },
    downloadPdf (index, row) {
      let filename = row.name
      // let pdfWindow = window.open('')
      // pdfWindow.document.write(`<p>Downloading ${row.type} with name ${row.name}...</p>`)
      axios.get(
        `${this.BASE_URL}/users/uid/applications/${this.appId}/attachments/${row.id}`)
        .then((response) => {
          // pdfWindow.document.write('<p>Done</p>')
          // pdfWindow.document.write("<encode width='100%' height='100%' src='data:application/pdf;base64, " +
          //   encodeURI(response.data.data.file[0]) + "'></iframe>")
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          let blob = new Blob(this.b64toBinary(response.data.data.file[0]), {type: 'octet/stream'})
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    calcType (num, name) {
      switch (num) {
        case 18:
          return 'Χειριστή: ' + name
        case 19:
          return 'Σχετική παλιότερη πράξη:' + ' ' + this.attachedDocumentsTable.slice(0).find(step => step.type === 19).name
        case 20:
          return 'Πράξη αναγνώρισης: ' + name
        case 21:
          return 'Προέλεγχος: ' + name
        case 22:
          return 'Προσχέδιο Πράξης αναγνώρισης: ' + name
        case 23:
          return 'ΑΝΑΘΕΩΡΗΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ: ' + name
        case 1005:
          return 'ΕΓΓΡΑΦΟ ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 1006:
          return 'ΕΙΣΗΓΗΣΗ ΕΙΔ.ΕΠΙΤΡ.ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 1014:
          return 'ΣΥΝΟΔΕΥΤΙΚΌ ΕΓΓΡΑΦΟ ΕΙΔ.ΕΠΙΤΡ.ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 1016:
          return 'ΕΠΙΣΚΟΠΗΣΗ ΑΙΤΗΣΗΣ ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 2007:
          return 'ΒΕΒΑΙΩΣΗ ΑΠΟΤΕΛΕΣΜΑΤΟΣ ΑΠΟ Π.Ι.: ' + name
        case 2008:
          return 'ΥΠΟΛΟΓΙΣΜΟΣ ΤΕΛΙΚΗΣ ΒΑΘΜΟΛΟΓΙΑΣ: ' + name
        case 1015:
          return 'ΠΡΑΚΤΙΚΌ Δ.Σ. ΓΙΑ ΕΙΣΗΓΗΣΗ ΕΙΔ.ΕΠΙΤΡ.ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 1007:
          return 'ΠΡΟΣΩΡΙΝΗ ΕΠΙΣΤΟΛΗ ΑΠΟΡΡΙΨΗΣ ΕΚΠΡΟΘΕΣΜΗΣ ΑΙΤΗΣΗΣ ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 1009:
          return 'ΠΡΟΣΩΡΙΝΗ ΕΠΙΣΤΟΛΗ ΕΜΜΟΝΗΣ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ: ' + name
        case 1008:
          return 'ΕΠΙΣΤΟΛΗ ΑΠΟΡΡΙΨΗΣ ΕΚΠΡΟΘΕΣΜΗΣ ΑΙΤΗΣΗΣ ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 1011:
          return 'ΑΝΑΘΕΩΡΗΜΕΝΗ ΕΠΙΣΤΟΛΗ ΑΠΟΡΡΙΨΗΣ ΕΚΠΡΟΘΕΣΜΗΣ ΑΙΤΗΣΗΣ ΕΠΑΝΕΞΕΤΑΣΗΣ: ' + name
        case 1010:
          return 'ΕΠΙΣΤΟΛΗ ΕΜΜΟΝΗΣ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ: ' + name
        case 1013:
          return 'ΑΝΑΘΕΩΡΗΜΕΝΗ ΕΠΙΣΤΟΛΗ ΕΜΜΟΝΗΣ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ: ' + name
        case 24:
          return 'ΠΡΑΚΤΙΚΟ Δ.Σ. (ΣΧΕΤ. Ε.Ε.): ' + name
        case 25:
          return 'ΕΙΣΗΓΗΣΗ ΕΚΤΕΛΕΣΤΙΚΗΣ ΕΠΙΤΡΟΠΗΣ: ' + name
        case 26:
          return 'ΠΡΑΚΤΙΚΟ Δ.Σ. (ΣΧΕΤ. Ε.Ε.Ε.): ' + name
        case 4:
          return 'ΥΠΕΥΘΥΝΗ ΔΗΛΩΣΗ'
        case 6:
          return 'ΑΠΟΛΥΤΗΡΙΟ ΛΥΚΕΙΟΥ'
        case 313:
          return 'ΠΙΣΤΟΠΟΙΗΤΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟΥ'
        case 999:
          return 'ΕΡΩΤΗΜΑΤΟΛΟΓΙΟ'
        case 1000:
          return 'ΑΝΑΓΝΩΡΙΣΗ ΚΥΣΑΤΣ'
        case 1002:
          return 'Υ/Δ ΠΑΡΑΚΟΛΟΥΘΗΣΗΣ ΣΤΗΝ ΕΔΡΑ ΤΟΥ ΠΑΝΕΠ. & ΑΠΟΔΕΙΚΤΙΚΟ ΕΠΑΡΚΕΙΑΣ ΓΛΩΣΣΑΣ  (ΑΓΓΛΟΦΩΝΑ ΒΟΥΛΓΑΡΙΑΣ)'
        case 1003:
          return 'ΠΙΣΤΟΠΟΙΗΤΙΚΟ ΕΓΚΡΙΣΗΣ ΑΠΟ ΤΟ ΥΠΟΥΡΓΕΙΟ'
        case 1001:
          return 'ΦΕΚ ΣΥΜΠΡΑΞΗΣ ΕΛΛΗΝΙΚΟΥ ΑΕΙ ΜΕ ΙΔΡΥΜΑ ΤΗΣ ΑΛΛΟΔΑΠΗΣ'
        case 998:
          return 'ΠΡΑΚΤΙΚΟ ΘΕΤΙΚΗΣ ΑΠΟΦΑΣΗΣ ΑΠΟΝΟΜΗΣ ΤΙΤΛΟΥ'
        case 997:
          return 'ΒΕΒΑΙΩΣΗ ΕΛΛΗΝΙΚΟΥ ΠΡΟΞΕΝΕΙΟΥ ΑΦΙΞΕΩΝ/ΑΝΑΧΩΡΗΣΕΩΝ ΣΤΗ ΧΩΡΑ'
        case 996:
          return 'ΑΠΟΔΕΙΚΤΙΚΟ ΕΠΑΡΚΕΙΑΣ ΓΛΩΣΣΑΣ'
        case 995:
          return 'ΒΑΘΜΙΔΑ ΚΥΡΙΟΥ ΕΠΙΒΛΕΠΟΝΤΟΣ ΔΙΔΑΚΤΟΡΙΚΗΣ ΔΙΑΤΡΙΒΗΣ'
        case 994:
          return 'ΒΕΒΑΙΩΣΗ ΕΞΕΤΑΣΗΣ ΜΑΘΗΜΑΤΩΝ'
        case 993:
          return 'ΒΕΒΑΙΩΣΗ ΓΙΑ ΤΗΝ ΗΜΕΡΟΜΗΝΙΑ ΕΓΓΡΑΦΗΣ ΚΑΙ ΠΕΡΑΤΩΣΗΣ ΤΩΝ ΣΠΟΥΔΩΝ'
        case 887:
          return 'ΝΤΟΣΙΕ ΕΡΓΑΣΙΩΝ (ΜΗΧΑΝΙΚΟΙ)'
        case 214:
          return 'ΟΔΗΓΟΣ ΣΠΟΥΔΩΝ (ΣΥΝΕΚΤΙΜΗΣΗ ΜΕΤΑΠΤΥΧΙΑΚΟΥ)'
        case 16:
          return 'ΕΝΤΥΠΟ ΣΥΓΚΑΤΑΘΕΣΗΣ (ΣΥΝΕΚΤΙΜΗΣΗ ΜΕΤΑΠΤΥΧΙΑΚΟ)'
        case 11:
          return 'ΒΕΒΑΙΩΣΗ ΥΠΟΤΡΟΦΙΑΣ'
        case 10:
          return 'ΑΝΑΓΝΩΡΙΣΗ ΙΔΡΥΜΑΤΟΣ'
        case 210:
          return 'ΜΕΤΑΠΤΥΧΙΑΚΟΣ ΤΙΤΛΟΣ'
        default:
          const neededDocType = this.neededDocuments.find(doc => doc.id === num)
          return neededDocType ? neededDocType.grName : `Τύπος εγγράφου ${num}: ${name}`
      }
      // return num !== 18 ? this.neededDocuments.find(doc => doc.id === num).grName : 'Εισηγητή: ' + name
      // this.application.applicationHistory.slice(0).reverse()
      //   .find(step => step.applicationStatus === 'presidentW_Prechecker').judgment.internalComment
    },
    generalCommentChanged () {
      this.$emit('changedGeneralComment', this.generalCommentWork)
    },
    commentChanged (index, row) {
      this.$emit('changedAttachedDocs', this.attachedDocs)
      this.$store.dispatch('SET_WORKING_APPLICATION_ATTACHMENTS', this.attachedDocs)
    },
    viewPdf (index, row) {
      // for download only
      // axios({
      //   url: 'http://api.dev/file-download',
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]))
      //   const link = document.createElement('a')
      //   link.href = url
      //   link.setAttribute('download', 'file.pdf')
      //   document.body.appendChild(link)
      //   link.click()
      // })
      axios.get(`${this.BASE_URL}/users/uid/applications/${this.appId}/attachments/${row.id}`)
        .then((response) => {
          const base64Data = encodeURI(response.data.data.file[0])
          this.openPdfWindow(row.name + ' (' + row.id + ')', base64Data)
        })
    },
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadError = null
    }
  },
  watch: {
    generalCommentWorking: function (newData, oldData) {
      this.generalCommentWork = newData
      this.$emit('changedGeneralComment', newData)
    }
  }
}
</script>

<style lang="scss">
  .select-all-docs {
    float: right;
    padding-right: 10px;
    height: 100%;
  }
  .biggest {
    &.el-textarea {
      width: 530px;
    }
  }
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: #bccce2;
    color: dimgray;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 140px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .el-table td, .el-table th {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/AttachedDocuments.vue